module.exports = __webpack_public_path__ + "a3012cfb991de6f4920a0d9bdc04150b.png";